/* tslint:disable */
/* eslint-disable */
/**
 * Mythic Global Event Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Configuration } from './configuration';
import globalAxios, {
  AxiosPromise,
  AxiosInstance,
  AxiosRequestConfig
} from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction
} from './common';
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  RequestArgs,
  BaseAPI,
  RequiredError
} from './base';

/**
 *
 * @export
 * @interface AuthorDto
 */
export interface AuthorDto {
  /**
   *
   * @type {string}
   * @memberof AuthorDto
   */
  account_id?: string | null;
  /**
   *
   * @type {string}
   * @memberof AuthorDto
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof AuthorDto
   */
  image_url?: string | null;
}
/**
 *
 * @export
 * @interface AuthorModel
 */
export interface AuthorModel {
  /**
   *
   * @type {string}
   * @memberof AuthorModel
   */
  accountId?: string | null;
  /**
   *
   * @type {string}
   * @memberof AuthorModel
   */
  authorName?: string | null;
  /**
   *
   * @type {string}
   * @memberof AuthorModel
   */
  imageUrl?: string | null;
}
/**
 *
 * @export
 * @interface BasicResponse
 */
export interface BasicResponse {
  /**
   *
   * @type {IError}
   * @memberof BasicResponse
   */
  error?: IError;
  /**
   *
   * @type {string}
   * @memberof BasicResponse
   */
  message?: string | null;
  /**
   *
   * @type {HttpStatusCode}
   * @memberof BasicResponse
   */
  statusCode?: HttpStatusCode;
}
/**
 *
 * @export
 * @interface CountryDto
 */
export interface CountryDto {
  /**
   *
   * @type {string}
   * @memberof CountryDto
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof CountryDto
   */
  name?: string | null;
  /**
   *
   * @type {number}
   * @memberof CountryDto
   */
  markerPositionX?: number;
  /**
   *
   * @type {number}
   * @memberof CountryDto
   */
  markerPositionY?: number;
  /**
   *
   * @type {number}
   * @memberof CountryDto
   */
  totalEvent?: number;
}
/**
 *
 * @export
 * @interface CountryDtoIGenericListResponse
 */
export interface CountryDtoIGenericListResponse {
  /**
   *
   * @type {Array<CountryDto>}
   * @memberof CountryDtoIGenericListResponse
   */
  data?: Array<CountryDto> | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof CountryDtoIGenericListResponse
   */
  meta?: { [key: string]: any } | null;
  /**
   *
   * @type {IError}
   * @memberof CountryDtoIGenericListResponse
   */
  error?: IError;
  /**
   *
   * @type {string}
   * @memberof CountryDtoIGenericListResponse
   */
  message?: string | null;
  /**
   *
   * @type {HttpStatusCode}
   * @memberof CountryDtoIGenericListResponse
   */
  statusCode?: HttpStatusCode;
}
/**
 *
 * @export
 * @interface CustomAttributeModel
 */
export interface CustomAttributeModel {
  /**
   *
   * @type {string}
   * @memberof CustomAttributeModel
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof CustomAttributeModel
   */
  value?: string | null;
}
/**
 *
 * @export
 * @interface DumDataHoverDto
 */
export interface DumDataHoverDto {
  /**
   *
   * @type {string}
   * @memberof DumDataHoverDto
   */
  id?: string | null;
  /**
   *
   * @type {DumLocationDto}
   * @memberof DumDataHoverDto
   */
  location?: DumLocationDto;
  /**
   *
   * @type {AuthorDto}
   * @memberof DumDataHoverDto
   */
  author?: AuthorDto;
  /**
   *
   * @type {Array<DumGlobalEventHoverDto>}
   * @memberof DumDataHoverDto
   */
  global_events?: Array<DumGlobalEventHoverDto> | null;
  /**
   *
   * @type {string}
   * @memberof DumDataHoverDto
   */
  dum_location_name?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof DumDataHoverDto
   */
  contain_mythic_event?: boolean;
  /**
   *
   * @type {string}
   * @memberof DumDataHoverDto
   */
  dum_date?: string;
}
/**
 *
 * @export
 * @interface DumDataHoverDtoListGenericResponse
 */
export interface DumDataHoverDtoListGenericResponse {
  /**
   *
   * @type {Array<DumDataHoverDto>}
   * @memberof DumDataHoverDtoListGenericResponse
   */
  data?: Array<DumDataHoverDto> | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof DumDataHoverDtoListGenericResponse
   */
  meta?: { [key: string]: any } | null;
  /**
   *
   * @type {IError}
   * @memberof DumDataHoverDtoListGenericResponse
   */
  error?: IError;
  /**
   *
   * @type {string}
   * @memberof DumDataHoverDtoListGenericResponse
   */
  message?: string | null;
  /**
   *
   * @type {HttpStatusCode}
   * @memberof DumDataHoverDtoListGenericResponse
   */
  statusCode?: HttpStatusCode;
}
/**
 *
 * @export
 * @interface DumDataSubmissionModel
 */
export interface DumDataSubmissionModel {
  /**
   *
   * @type {string}
   * @memberof DumDataSubmissionModel
   */
  countryId?: string | null;
  /**
   *
   * @type {AuthorModel}
   * @memberof DumDataSubmissionModel
   */
  author?: AuthorModel;
  /**
   *
   * @type {DumLocationModel}
   * @memberof DumDataSubmissionModel
   */
  location?: DumLocationModel;
  /**
   *
   * @type {string}
   * @memberof DumDataSubmissionModel
   */
  dumDate?: string;
  /**
   *
   * @type {string}
   * @memberof DumDataSubmissionModel
   */
  dumLocationName?: string | null;
  /**
   *
   * @type {Status}
   * @memberof DumDataSubmissionModel
   */
  status?: Status;
  /**
   *
   * @type {boolean}
   * @memberof DumDataSubmissionModel
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof DumDataSubmissionModel
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof DumDataSubmissionModel
   */
  createDate?: string;
  /**
   *
   * @type {string}
   * @memberof DumDataSubmissionModel
   */
  updateDate?: string;
  /**
   *
   * @type {number}
   * @memberof DumDataSubmissionModel
   */
  dataVer?: number;
}
/**
 *
 * @export
 * @interface DumDataSubmissionModelGenericResponse
 */
export interface DumDataSubmissionModelGenericResponse {
  /**
   *
   * @type {DumDataSubmissionModel}
   * @memberof DumDataSubmissionModelGenericResponse
   */
  data?: DumDataSubmissionModel;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof DumDataSubmissionModelGenericResponse
   */
  meta?: { [key: string]: any } | null;
  /**
   *
   * @type {IError}
   * @memberof DumDataSubmissionModelGenericResponse
   */
  error?: IError;
  /**
   *
   * @type {string}
   * @memberof DumDataSubmissionModelGenericResponse
   */
  message?: string | null;
  /**
   *
   * @type {HttpStatusCode}
   * @memberof DumDataSubmissionModelGenericResponse
   */
  statusCode?: HttpStatusCode;
}
/**
 *
 * @export
 * @interface DumGlobalEventDetailsDto
 */
export interface DumGlobalEventDetailsDto {
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventDetailsDto
   */
  product_reference?: string | null;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventDetailsDto
   */
  description?: string | null;
  /**
   *
   * @type {Array<DumGlobalEventMediaSupportDto>}
   * @memberof DumGlobalEventDetailsDto
   */
  event_media_supports?: Array<DumGlobalEventMediaSupportDto> | null;
  /**
   *
   * @type {Array<CustomAttributeModel>}
   * @memberof DumGlobalEventDetailsDto
   */
  custom_attributes?: Array<CustomAttributeModel> | null;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventDetailsDto
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventDetailsDto
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventDetailsDto
   */
  event_date?: string;
  /**
   *
   * @type {number}
   * @memberof DumGlobalEventDetailsDto
   */
  product_type?: number;
  /**
   *
   * @type {AuthorDto}
   * @memberof DumGlobalEventDetailsDto
   */
  author?: AuthorDto;
  /**
   *
   * @type {number}
   * @memberof DumGlobalEventDetailsDto
   */
  status?: number;
}
/**
 *
 * @export
 * @interface DumGlobalEventDetailsDtoListGenericResponse
 */
export interface DumGlobalEventDetailsDtoListGenericResponse {
  /**
   *
   * @type {Array<DumGlobalEventDetailsDto>}
   * @memberof DumGlobalEventDetailsDtoListGenericResponse
   */
  data?: Array<DumGlobalEventDetailsDto> | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof DumGlobalEventDetailsDtoListGenericResponse
   */
  meta?: { [key: string]: any } | null;
  /**
   *
   * @type {IError}
   * @memberof DumGlobalEventDetailsDtoListGenericResponse
   */
  error?: IError;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventDetailsDtoListGenericResponse
   */
  message?: string | null;
  /**
   *
   * @type {HttpStatusCode}
   * @memberof DumGlobalEventDetailsDtoListGenericResponse
   */
  statusCode?: HttpStatusCode;
}
/**
 *
 * @export
 * @interface DumGlobalEventHoverDto
 */
export interface DumGlobalEventHoverDto {
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventHoverDto
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventHoverDto
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventHoverDto
   */
  event_date?: string;
  /**
   *
   * @type {number}
   * @memberof DumGlobalEventHoverDto
   */
  product_type?: number;
  /**
   *
   * @type {AuthorDto}
   * @memberof DumGlobalEventHoverDto
   */
  author?: AuthorDto;
  /**
   *
   * @type {number}
   * @memberof DumGlobalEventHoverDto
   */
  status?: number;
}
/**
 *
 * @export
 * @interface DumGlobalEventMediaSupportDto
 */
export interface DumGlobalEventMediaSupportDto {
  /**
   *
   * @type {MediaType}
   * @memberof DumGlobalEventMediaSupportDto
   */
  media_type?: MediaType;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventMediaSupportDto
   */
  url?: string | null;
}
/**
 *
 * @export
 * @interface DumGlobalEventSubmissionListDto
 */
export interface DumGlobalEventSubmissionListDto {
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventSubmissionListDto
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventSubmissionListDto
   */
  dumId?: string | null;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventSubmissionListDto
   */
  name?: string | null;
  /**
   *
   * @type {number}
   * @memberof DumGlobalEventSubmissionListDto
   */
  product_type?: number;
  /**
   *
   * @type {AuthorDto}
   * @memberof DumGlobalEventSubmissionListDto
   */
  author?: AuthorDto;
  /**
   *
   * @type {DumLocationModel}
   * @memberof DumGlobalEventSubmissionListDto
   */
  location?: DumLocationModel;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventSubmissionListDto
   */
  dumLocationName?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof DumGlobalEventSubmissionListDto
   */
  containMythicEvent?: boolean;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventSubmissionListDto
   */
  eventDate?: string;
  /**
   *
   * @type {number}
   * @memberof DumGlobalEventSubmissionListDto
   */
  status?: number;
}
/**
 *
 * @export
 * @interface DumGlobalEventSubmissionListDtoListGenericResponse
 */
export interface DumGlobalEventSubmissionListDtoListGenericResponse {
  /**
   *
   * @type {Array<DumGlobalEventSubmissionListDto>}
   * @memberof DumGlobalEventSubmissionListDtoListGenericResponse
   */
  data?: Array<DumGlobalEventSubmissionListDto> | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof DumGlobalEventSubmissionListDtoListGenericResponse
   */
  meta?: { [key: string]: any } | null;
  /**
   *
   * @type {IError}
   * @memberof DumGlobalEventSubmissionListDtoListGenericResponse
   */
  error?: IError;
  /**
   *
   * @type {string}
   * @memberof DumGlobalEventSubmissionListDtoListGenericResponse
   */
  message?: string | null;
  /**
   *
   * @type {HttpStatusCode}
   * @memberof DumGlobalEventSubmissionListDtoListGenericResponse
   */
  statusCode?: HttpStatusCode;
}
/**
 *
 * @export
 * @interface DumLocationDto
 */
export interface DumLocationDto {
  /**
   *
   * @type {number}
   * @memberof DumLocationDto
   */
  latitude?: number;
  /**
   *
   * @type {number}
   * @memberof DumLocationDto
   */
  longitude?: number;
  /**
   *
   * @type {string}
   * @memberof DumLocationDto
   */
  location_name?: string | null;
}
/**
 *
 * @export
 * @interface DumLocationModel
 */
export interface DumLocationModel {
  /**
   *
   * @type {string}
   * @memberof DumLocationModel
   */
  locationName?: string | null;
  /**
   *
   * @type {number}
   * @memberof DumLocationModel
   */
  latitude?: number;
  /**
   *
   * @type {number}
   * @memberof DumLocationModel
   */
  longitude?: number;
}
/**
 *
 * @export
 * @interface DumOverviewGetDto
 */
export interface DumOverviewGetDto {
  /**
   *
   * @type {Array<SliderData>}
   * @memberof DumOverviewGetDto
   */
  slider_data?: Array<SliderData> | null;
}
/**
 *
 * @export
 * @interface DumOverviewGetDtoGenericResponse
 */
export interface DumOverviewGetDtoGenericResponse {
  /**
   *
   * @type {DumOverviewGetDto}
   * @memberof DumOverviewGetDtoGenericResponse
   */
  data?: DumOverviewGetDto;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof DumOverviewGetDtoGenericResponse
   */
  meta?: { [key: string]: any } | null;
  /**
   *
   * @type {IError}
   * @memberof DumOverviewGetDtoGenericResponse
   */
  error?: IError;
  /**
   *
   * @type {string}
   * @memberof DumOverviewGetDtoGenericResponse
   */
  message?: string | null;
  /**
   *
   * @type {HttpStatusCode}
   * @memberof DumOverviewGetDtoGenericResponse
   */
  statusCode?: HttpStatusCode;
}
/**
 *
 * @export
 * @interface EventMediaSupportModel
 */
export interface EventMediaSupportModel {
  /**
   *
   * @type {MediaType}
   * @memberof EventMediaSupportModel
   */
  mediaType?: MediaType;
  /**
   *
   * @type {string}
   * @memberof EventMediaSupportModel
   */
  url?: string | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const EventType = {
  HumanActivities: 'HumanActivities',
  ParanormalActivities: 'ParanormalActivities',
  NaturalDisaster: 'NaturalDisaster',
  SupranaturalActivities: 'SupranaturalActivities'
} as const;

export type EventType = (typeof EventType)[keyof typeof EventType];

/**
 *
 * @export
 * @interface GlobalEventDto
 */
export interface GlobalEventDto {
  /**
   *
   * @type {string}
   * @memberof GlobalEventDto
   */
  id?: string | null;
  /**
   *
   * @type {DumLocationDto}
   * @memberof GlobalEventDto
   */
  location?: DumLocationDto;
  /**
   *
   * @type {AuthorDto}
   * @memberof GlobalEventDto
   */
  author?: AuthorDto;
  /**
   *
   * @type {string}
   * @memberof GlobalEventDto
   */
  dum_location_name?: string | null;
  /**
   *
   * @type {string}
   * @memberof GlobalEventDto
   */
  event_name?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof GlobalEventDto
   */
  contain_mythic_event?: boolean;
  /**
   *
   * @type {string}
   * @memberof GlobalEventDto
   */
  dum_date?: string;
}
/**
 *
 * @export
 * @interface GlobalEventDtoListGenericResponse
 */
export interface GlobalEventDtoListGenericResponse {
  /**
   *
   * @type {Array<GlobalEventDto>}
   * @memberof GlobalEventDtoListGenericResponse
   */
  data?: Array<GlobalEventDto> | null;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof GlobalEventDtoListGenericResponse
   */
  meta?: { [key: string]: any } | null;
  /**
   *
   * @type {IError}
   * @memberof GlobalEventDtoListGenericResponse
   */
  error?: IError;
  /**
   *
   * @type {string}
   * @memberof GlobalEventDtoListGenericResponse
   */
  message?: string | null;
  /**
   *
   * @type {HttpStatusCode}
   * @memberof GlobalEventDtoListGenericResponse
   */
  statusCode?: HttpStatusCode;
}
/**
 *
 * @export
 * @interface GlobalEventSubmissionModel
 */
export interface GlobalEventSubmissionModel {
  /**
   *
   * @type {string}
   * @memberof GlobalEventSubmissionModel
   */
  dumId?: string | null;
  /**
   *
   * @type {Status}
   * @memberof GlobalEventSubmissionModel
   */
  status?: Status;
  /**
   *
   * @type {AuthorModel}
   * @memberof GlobalEventSubmissionModel
   */
  author?: AuthorModel;
  /**
   *
   * @type {string}
   * @memberof GlobalEventSubmissionModel
   */
  name?: string | null;
  /**
   *
   * @type {string}
   * @memberof GlobalEventSubmissionModel
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof GlobalEventSubmissionModel
   */
  eventDate?: string;
  /**
   *
   * @type {string}
   * @memberof GlobalEventSubmissionModel
   */
  productReference?: string | null;
  /**
   *
   * @type {ProductType}
   * @memberof GlobalEventSubmissionModel
   */
  productType?: ProductType;
  /**
   *
   * @type {EventType}
   * @memberof GlobalEventSubmissionModel
   */
  eventType?: EventType;
  /**
   *
   * @type {Array<EventMediaSupportModel>}
   * @memberof GlobalEventSubmissionModel
   */
  eventMediaSupports?: Array<EventMediaSupportModel> | null;
  /**
   *
   * @type {Array<CustomAttributeModel>}
   * @memberof GlobalEventSubmissionModel
   */
  customAttributes?: Array<CustomAttributeModel> | null;
  /**
   *
   * @type {boolean}
   * @memberof GlobalEventSubmissionModel
   */
  isDeleted?: boolean;
  /**
   *
   * @type {string}
   * @memberof GlobalEventSubmissionModel
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof GlobalEventSubmissionModel
   */
  createDate?: string;
  /**
   *
   * @type {string}
   * @memberof GlobalEventSubmissionModel
   */
  updateDate?: string;
  /**
   *
   * @type {number}
   * @memberof GlobalEventSubmissionModel
   */
  dataVer?: number;
}
/**
 *
 * @export
 * @interface GlobalEventSubmissionModelGenericResponse
 */
export interface GlobalEventSubmissionModelGenericResponse {
  /**
   *
   * @type {GlobalEventSubmissionModel}
   * @memberof GlobalEventSubmissionModelGenericResponse
   */
  data?: GlobalEventSubmissionModel;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof GlobalEventSubmissionModelGenericResponse
   */
  meta?: { [key: string]: any } | null;
  /**
   *
   * @type {IError}
   * @memberof GlobalEventSubmissionModelGenericResponse
   */
  error?: IError;
  /**
   *
   * @type {string}
   * @memberof GlobalEventSubmissionModelGenericResponse
   */
  message?: string | null;
  /**
   *
   * @type {HttpStatusCode}
   * @memberof GlobalEventSubmissionModelGenericResponse
   */
  statusCode?: HttpStatusCode;
}
/**
 *
 * @export
 * @interface HealthResponseModel
 */
export interface HealthResponseModel {
  /**
   *
   * @type {boolean}
   * @memberof HealthResponseModel
   */
  status?: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const HttpStatusCode = {
  Continue: 'Continue',
  SwitchingProtocols: 'SwitchingProtocols',
  Processing: 'Processing',
  EarlyHints: 'EarlyHints',
  Ok: 'OK',
  Created: 'Created',
  Accepted: 'Accepted',
  NonAuthoritativeInformation: 'NonAuthoritativeInformation',
  NoContent: 'NoContent',
  ResetContent: 'ResetContent',
  PartialContent: 'PartialContent',
  MultiStatus: 'MultiStatus',
  AlreadyReported: 'AlreadyReported',
  ImUsed: 'IMUsed',
  Ambiguous: 'Ambiguous',
  Moved: 'Moved',
  Redirect: 'Redirect',
  RedirectMethod: 'RedirectMethod',
  NotModified: 'NotModified',
  UseProxy: 'UseProxy',
  Unused: 'Unused',
  TemporaryRedirect: 'TemporaryRedirect',
  PermanentRedirect: 'PermanentRedirect',
  BadRequest: 'BadRequest',
  Unauthorized: 'Unauthorized',
  PaymentRequired: 'PaymentRequired',
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  MethodNotAllowed: 'MethodNotAllowed',
  NotAcceptable: 'NotAcceptable',
  ProxyAuthenticationRequired: 'ProxyAuthenticationRequired',
  RequestTimeout: 'RequestTimeout',
  Conflict: 'Conflict',
  Gone: 'Gone',
  LengthRequired: 'LengthRequired',
  PreconditionFailed: 'PreconditionFailed',
  RequestEntityTooLarge: 'RequestEntityTooLarge',
  RequestUriTooLong: 'RequestUriTooLong',
  UnsupportedMediaType: 'UnsupportedMediaType',
  RequestedRangeNotSatisfiable: 'RequestedRangeNotSatisfiable',
  ExpectationFailed: 'ExpectationFailed',
  MisdirectedRequest: 'MisdirectedRequest',
  UnprocessableEntity: 'UnprocessableEntity',
  Locked: 'Locked',
  FailedDependency: 'FailedDependency',
  UpgradeRequired: 'UpgradeRequired',
  PreconditionRequired: 'PreconditionRequired',
  TooManyRequests: 'TooManyRequests',
  RequestHeaderFieldsTooLarge: 'RequestHeaderFieldsTooLarge',
  UnavailableForLegalReasons: 'UnavailableForLegalReasons',
  InternalServerError: 'InternalServerError',
  NotImplemented: 'NotImplemented',
  BadGateway: 'BadGateway',
  ServiceUnavailable: 'ServiceUnavailable',
  GatewayTimeout: 'GatewayTimeout',
  HttpVersionNotSupported: 'HttpVersionNotSupported',
  VariantAlsoNegotiates: 'VariantAlsoNegotiates',
  InsufficientStorage: 'InsufficientStorage',
  LoopDetected: 'LoopDetected',
  NotExtended: 'NotExtended',
  NetworkAuthenticationRequired: 'NetworkAuthenticationRequired'
} as const;

export type HttpStatusCode =
  (typeof HttpStatusCode)[keyof typeof HttpStatusCode];

/**
 *
 * @export
 * @interface IError
 */
export interface IError {
  /**
   *
   * @type {string}
   * @memberof IError
   */
  code?: string | null;
  /**
   *
   * @type {string}
   * @memberof IError
   */
  message?: string | null;
  /**
   *
   * @type {string}
   * @memberof IError
   */
  target?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof IError
   */
  details?: Array<any> | null;
  /**
   *
   * @type {IInnerError}
   * @memberof IError
   */
  innererror?: IInnerError;
}
/**
 *
 * @export
 * @interface IInnerError
 */
export interface IInnerError {
  /**
   *
   * @type {string}
   * @memberof IInnerError
   */
  code?: string | null;
  /**
   *
   * @type {IInnerError}
   * @memberof IInnerError
   */
  innererror?: IInnerError;
}
/**
 *
 * @export
 * @enum {string}
 */

export const MediaType = {
  Image: 'Image',
  Video: 'Video',
  Casefile: 'Casefile'
} as const;

export type MediaType = (typeof MediaType)[keyof typeof MediaType];

/**
 *
 * @export
 * @interface ModelError
 */
export interface ModelError {
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  code?: string | null;
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  message?: string | null;
  /**
   *
   * @type {string}
   * @memberof ModelError
   */
  target?: string | null;
  /**
   *
   * @type {Array<any>}
   * @memberof ModelError
   */
  details?: Array<any> | null;
  /**
   *
   * @type {IInnerError}
   * @memberof ModelError
   */
  innererror?: IInnerError;
}
/**
 *
 * @export
 * @interface MonthSliderData
 */
export interface MonthSliderData {
  /**
   *
   * @type {number}
   * @memberof MonthSliderData
   */
  month?: number;
  /**
   *
   * @type {boolean}
   * @memberof MonthSliderData
   */
  contain_mythic_event?: boolean;
}
/**
 *
 * @export
 * @enum {string}
 */

export const ProductType = {
  MythicEvent: 'MythicEvent',
  RiftStorm: 'RiftStorm',
  Repository: 'Repository',
  MythicReport: 'MythicReport'
} as const;

export type ProductType = (typeof ProductType)[keyof typeof ProductType];

/**
 *
 * @export
 * @interface SliderData
 */
export interface SliderData {
  /**
   *
   * @type {number}
   * @memberof SliderData
   */
  year?: number;
  /**
   *
   * @type {Array<MonthSliderData>}
   * @memberof SliderData
   */
  months?: Array<MonthSliderData> | null;
}
/**
 *
 * @export
 * @enum {string}
 */

export const Status = {
  Draft: 'Draft',
  Rejected: 'Rejected',
  OnReview: 'OnReview',
  Approved: 'Approved',
  Uncovered: 'Uncovered'
} as const;

export type Status = (typeof Status)[keyof typeof Status];

/**
 * CountryQueryApi - axios parameter creator
 * @export
 */
export const CountryQueryApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countryGet: async (
      apiVersion?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/country`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (apiVersion !== undefined && apiVersion !== null) {
        localVarHeaderParameter['api-version'] = String(apiVersion);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * CountryQueryApi - functional programming interface
 * @export
 */
export const CountryQueryApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    CountryQueryApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async countryGet(
      apiVersion?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<CountryDtoIGenericListResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.countryGet(
        apiVersion,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    }
  };
};

/**
 * CountryQueryApi - factory interface
 * @export
 */
export const CountryQueryApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = CountryQueryApiFp(configuration);
  return {
    /**
     *
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    countryGet(
      apiVersion?: string,
      options?: any
    ): AxiosPromise<CountryDtoIGenericListResponse> {
      return localVarFp
        .countryGet(apiVersion, options)
        .then((request) => request(axios, basePath));
    }
  };
};

/**
 * CountryQueryApi - object-oriented interface
 * @export
 * @class CountryQueryApi
 * @extends {BaseAPI}
 */
export class CountryQueryApi extends BaseAPI {
  /**
   *
   * @param {string} [apiVersion] The requested API version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CountryQueryApi
   */
  public countryGet(apiVersion?: string, options?: AxiosRequestConfig) {
    return CountryQueryApiFp(this.configuration)
      .countryGet(apiVersion, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DumCommandApi - axios parameter creator
 * @export
 */
export const DumCommandApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} dumId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [name]
     * @param {string} [description]
     * @param {string} [reference]
     * @param {string} [eventDate]
     * @param {string} [captchaToken]
     * @param {any} [banner]
     * @param {string} [bannerUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dumEventDumIdPost: async (
      dumId: string,
      apiVersion?: string,
      name?: string,
      description?: string,
      reference?: string,
      eventDate?: string,
      captchaToken?: string,
      banner?: any,
      bannerUrl?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'dumId' is not null or undefined
      assertParamExists('dumEventDumIdPost', 'dumId', dumId);
      const localVarPath = `/dum/event/{dumId}`.replace(
        `{${'dumId'}}`,
        encodeURIComponent(String(dumId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (apiVersion !== undefined && apiVersion !== null) {
        localVarHeaderParameter['api-version'] = String(apiVersion);
      }

      if (name !== undefined) {
        localVarFormParams.append('name', name as any);
      }

      if (description !== undefined) {
        localVarFormParams.append('description', description as any);
      }

      if (reference !== undefined) {
        localVarFormParams.append('reference', reference as any);
      }

      if (eventDate !== undefined) {
        localVarFormParams.append('eventDate', eventDate as any);
      }

      if (captchaToken !== undefined) {
        localVarFormParams.append('captchaToken', captchaToken as any);
      }

      if (banner !== undefined) {
        localVarFormParams.append('banner', banner as any);
      }

      if (bannerUrl !== undefined) {
        localVarFormParams.append('banner_url', bannerUrl as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} [apiVersion] The requested API version
     * @param {number} [latitude]
     * @param {number} [longitude]
     * @param {string} [eventDate]
     * @param {string} [name]
     * @param {string} [description]
     * @param {string} [reference]
     * @param {string} [captchaToken]
     * @param {any} [banner]
     * @param {string} [bannerUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dumEventPost: async (
      apiVersion?: string,
      latitude?: number,
      longitude?: number,
      eventDate?: string,
      name?: string,
      description?: string,
      reference?: string,
      captchaToken?: string,
      banner?: any,
      bannerUrl?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/dum/event`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'POST',
        ...baseOptions,
        ...options
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;
      const localVarFormParams = new ((configuration &&
        configuration.formDataCtor) ||
        FormData)();

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (apiVersion !== undefined && apiVersion !== null) {
        localVarHeaderParameter['api-version'] = String(apiVersion);
      }

      if (latitude !== undefined) {
        localVarFormParams.append('latitude', latitude as any);
      }

      if (longitude !== undefined) {
        localVarFormParams.append('longitude', longitude as any);
      }

      if (eventDate !== undefined) {
        localVarFormParams.append('eventDate', eventDate as any);
      }

      if (name !== undefined) {
        localVarFormParams.append('name', name as any);
      }

      if (description !== undefined) {
        localVarFormParams.append('description', description as any);
      }

      if (reference !== undefined) {
        localVarFormParams.append('reference', reference as any);
      }

      if (captchaToken !== undefined) {
        localVarFormParams.append('captchaToken', captchaToken as any);
      }

      if (banner !== undefined) {
        localVarFormParams.append('banner', banner as any);
      }

      if (bannerUrl !== undefined) {
        localVarFormParams.append('banner_url', bannerUrl as any);
      }

      localVarHeaderParameter['Content-Type'] = 'multipart/form-data';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };
      localVarRequestOptions.data = localVarFormParams;

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * DumCommandApi - functional programming interface
 * @export
 */
export const DumCommandApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    DumCommandApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} dumId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [name]
     * @param {string} [description]
     * @param {string} [reference]
     * @param {string} [eventDate]
     * @param {string} [captchaToken]
     * @param {any} [banner]
     * @param {string} [bannerUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dumEventDumIdPost(
      dumId: string,
      apiVersion?: string,
      name?: string,
      description?: string,
      reference?: string,
      eventDate?: string,
      captchaToken?: string,
      banner?: any,
      bannerUrl?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GlobalEventSubmissionModelGenericResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.dumEventDumIdPost(
          dumId,
          apiVersion,
          name,
          description,
          reference,
          eventDate,
          captchaToken,
          banner,
          bannerUrl,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} [apiVersion] The requested API version
     * @param {number} [latitude]
     * @param {number} [longitude]
     * @param {string} [eventDate]
     * @param {string} [name]
     * @param {string} [description]
     * @param {string} [reference]
     * @param {string} [captchaToken]
     * @param {any} [banner]
     * @param {string} [bannerUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dumEventPost(
      apiVersion?: string,
      latitude?: number,
      longitude?: number,
      eventDate?: string,
      name?: string,
      description?: string,
      reference?: string,
      captchaToken?: string,
      banner?: any,
      bannerUrl?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DumDataSubmissionModelGenericResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dumEventPost(
        apiVersion,
        latitude,
        longitude,
        eventDate,
        name,
        description,
        reference,
        captchaToken,
        banner,
        bannerUrl,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    }
  };
};

/**
 * DumCommandApi - factory interface
 * @export
 */
export const DumCommandApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DumCommandApiFp(configuration);
  return {
    /**
     *
     * @param {string} dumId
     * @param {string} [apiVersion] The requested API version
     * @param {string} [name]
     * @param {string} [description]
     * @param {string} [reference]
     * @param {string} [eventDate]
     * @param {string} [captchaToken]
     * @param {any} [banner]
     * @param {string} [bannerUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dumEventDumIdPost(
      dumId: string,
      apiVersion?: string,
      name?: string,
      description?: string,
      reference?: string,
      eventDate?: string,
      captchaToken?: string,
      banner?: any,
      bannerUrl?: string,
      options?: any
    ): AxiosPromise<GlobalEventSubmissionModelGenericResponse> {
      return localVarFp
        .dumEventDumIdPost(
          dumId,
          apiVersion,
          name,
          description,
          reference,
          eventDate,
          captchaToken,
          banner,
          bannerUrl,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [apiVersion] The requested API version
     * @param {number} [latitude]
     * @param {number} [longitude]
     * @param {string} [eventDate]
     * @param {string} [name]
     * @param {string} [description]
     * @param {string} [reference]
     * @param {string} [captchaToken]
     * @param {any} [banner]
     * @param {string} [bannerUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dumEventPost(
      apiVersion?: string,
      latitude?: number,
      longitude?: number,
      eventDate?: string,
      name?: string,
      description?: string,
      reference?: string,
      captchaToken?: string,
      banner?: any,
      bannerUrl?: string,
      options?: any
    ): AxiosPromise<DumDataSubmissionModelGenericResponse> {
      return localVarFp
        .dumEventPost(
          apiVersion,
          latitude,
          longitude,
          eventDate,
          name,
          description,
          reference,
          captchaToken,
          banner,
          bannerUrl,
          options
        )
        .then((request) => request(axios, basePath));
    }
  };
};

/**
 * DumCommandApi - object-oriented interface
 * @export
 * @class DumCommandApi
 * @extends {BaseAPI}
 */
export class DumCommandApi extends BaseAPI {
  /**
   *
   * @param {string} dumId
   * @param {string} [apiVersion] The requested API version
   * @param {string} [name]
   * @param {string} [description]
   * @param {string} [reference]
   * @param {string} [eventDate]
   * @param {string} [captchaToken]
   * @param {any} [banner]
   * @param {string} [bannerUrl]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DumCommandApi
   */
  public dumEventDumIdPost(
    dumId: string,
    apiVersion?: string,
    name?: string,
    description?: string,
    reference?: string,
    eventDate?: string,
    captchaToken?: string,
    banner?: any,
    bannerUrl?: string,
    options?: AxiosRequestConfig
  ) {
    return DumCommandApiFp(this.configuration)
      .dumEventDumIdPost(
        dumId,
        apiVersion,
        name,
        description,
        reference,
        eventDate,
        captchaToken,
        banner,
        bannerUrl,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [apiVersion] The requested API version
   * @param {number} [latitude]
   * @param {number} [longitude]
   * @param {string} [eventDate]
   * @param {string} [name]
   * @param {string} [description]
   * @param {string} [reference]
   * @param {string} [captchaToken]
   * @param {any} [banner]
   * @param {string} [bannerUrl]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DumCommandApi
   */
  public dumEventPost(
    apiVersion?: string,
    latitude?: number,
    longitude?: number,
    eventDate?: string,
    name?: string,
    description?: string,
    reference?: string,
    captchaToken?: string,
    banner?: any,
    bannerUrl?: string,
    options?: AxiosRequestConfig
  ) {
    return DumCommandApiFp(this.configuration)
      .dumEventPost(
        apiVersion,
        latitude,
        longitude,
        eventDate,
        name,
        description,
        reference,
        captchaToken,
        banner,
        bannerUrl,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * DumQueryApi - axios parameter creator
 * @export
 */
export const DumQueryApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} accountId
     * @param {Array<string>} [specificCountry]
     * @param {Array<number>} [toggleAnomalyRating]
     * @param {Array<number>} [status]
     * @param {string} [previousId]
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dumAccountIdGet: async (
      accountId: string,
      specificCountry?: Array<string>,
      toggleAnomalyRating?: Array<number>,
      status?: Array<number>,
      previousId?: string,
      apiVersion?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'accountId' is not null or undefined
      assertParamExists('dumAccountIdGet', 'accountId', accountId);
      const localVarPath = `/dum/{accountId}`.replace(
        `{${'accountId'}}`,
        encodeURIComponent(String(accountId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (specificCountry) {
        localVarQueryParameter['SpecificCountry'] = specificCountry;
      }

      if (toggleAnomalyRating) {
        localVarQueryParameter['ToggleAnomalyRating'] = toggleAnomalyRating;
      }

      if (status) {
        localVarQueryParameter['Status'] = status;
      }

      if (previousId !== undefined) {
        localVarQueryParameter['PreviousId'] = previousId;
      }

      if (apiVersion !== undefined && apiVersion !== null) {
        localVarHeaderParameter['api-version'] = String(apiVersion);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dumEventIdGet: async (
      id: string,
      apiVersion?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dumEventIdGet', 'id', id);
      const localVarPath = `/dum/event/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (apiVersion !== undefined && apiVersion !== null) {
        localVarHeaderParameter['api-version'] = String(apiVersion);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {number} [year]
     * @param {number} [month]
     * @param {string} [eventName]
     * @param {string} [previousDumId]
     * @param {number} [location]
     * @param {Array<string>} [specificCountry]
     * @param {Array<number>} [ecosystem]
     * @param {Array<number>} [toggleAnomalyRating]
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dumGet: async (
      year?: number,
      month?: number,
      eventName?: string,
      previousDumId?: string,
      location?: number,
      specificCountry?: Array<string>,
      ecosystem?: Array<number>,
      toggleAnomalyRating?: Array<number>,
      apiVersion?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/dum`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (year !== undefined) {
        localVarQueryParameter['Year'] = year;
      }

      if (month !== undefined) {
        localVarQueryParameter['Month'] = month;
      }

      if (eventName !== undefined) {
        localVarQueryParameter['EventName'] = eventName;
      }

      if (previousDumId !== undefined) {
        localVarQueryParameter['PreviousDumId'] = previousDumId;
      }

      if (location !== undefined) {
        localVarQueryParameter['Location'] = location;
      }

      if (specificCountry) {
        localVarQueryParameter['SpecificCountry'] = specificCountry;
      }

      if (ecosystem) {
        localVarQueryParameter['Ecosystem'] = ecosystem;
      }

      if (toggleAnomalyRating) {
        localVarQueryParameter['ToggleAnomalyRating'] = toggleAnomalyRating;
      }

      if (apiVersion !== undefined && apiVersion !== null) {
        localVarHeaderParameter['api-version'] = String(apiVersion);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {number} [startYear]
     * @param {number} [endYear]
     * @param {number} [location]
     * @param {Array<string>} [specificCountry]
     * @param {Array<number>} [ecosystem]
     * @param {Array<number>} [toggleAnomalyRating]
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dumOverviewGet: async (
      startYear?: number,
      endYear?: number,
      location?: number,
      specificCountry?: Array<string>,
      ecosystem?: Array<number>,
      toggleAnomalyRating?: Array<number>,
      apiVersion?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/dum/overview`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (startYear !== undefined) {
        localVarQueryParameter['StartYear'] = startYear;
      }

      if (endYear !== undefined) {
        localVarQueryParameter['EndYear'] = endYear;
      }

      if (location !== undefined) {
        localVarQueryParameter['Location'] = location;
      }

      if (specificCountry) {
        localVarQueryParameter['SpecificCountry'] = specificCountry;
      }

      if (ecosystem) {
        localVarQueryParameter['Ecosystem'] = ecosystem;
      }

      if (toggleAnomalyRating) {
        localVarQueryParameter['ToggleAnomalyRating'] = toggleAnomalyRating;
      }

      if (apiVersion !== undefined && apiVersion !== null) {
        localVarHeaderParameter['api-version'] = String(apiVersion);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * DumQueryApi - functional programming interface
 * @export
 */
export const DumQueryApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DumQueryApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} accountId
     * @param {Array<string>} [specificCountry]
     * @param {Array<number>} [toggleAnomalyRating]
     * @param {Array<number>} [status]
     * @param {string} [previousId]
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dumAccountIdGet(
      accountId: string,
      specificCountry?: Array<string>,
      toggleAnomalyRating?: Array<number>,
      status?: Array<number>,
      previousId?: string,
      apiVersion?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DumGlobalEventSubmissionListDtoListGenericResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dumAccountIdGet(
        accountId,
        specificCountry,
        toggleAnomalyRating,
        status,
        previousId,
        apiVersion,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dumEventIdGet(
      id: string,
      apiVersion?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DumGlobalEventDetailsDtoListGenericResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dumEventIdGet(
        id,
        apiVersion,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} [year]
     * @param {number} [month]
     * @param {string} [eventName]
     * @param {string} [previousDumId]
     * @param {number} [location]
     * @param {Array<string>} [specificCountry]
     * @param {Array<number>} [ecosystem]
     * @param {Array<number>} [toggleAnomalyRating]
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dumGet(
      year?: number,
      month?: number,
      eventName?: string,
      previousDumId?: string,
      location?: number,
      specificCountry?: Array<string>,
      ecosystem?: Array<number>,
      toggleAnomalyRating?: Array<number>,
      apiVersion?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DumDataHoverDtoListGenericResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dumGet(
        year,
        month,
        eventName,
        previousDumId,
        location,
        specificCountry,
        ecosystem,
        toggleAnomalyRating,
        apiVersion,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {number} [startYear]
     * @param {number} [endYear]
     * @param {number} [location]
     * @param {Array<string>} [specificCountry]
     * @param {Array<number>} [ecosystem]
     * @param {Array<number>} [toggleAnomalyRating]
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dumOverviewGet(
      startYear?: number,
      endYear?: number,
      location?: number,
      specificCountry?: Array<string>,
      ecosystem?: Array<number>,
      toggleAnomalyRating?: Array<number>,
      apiVersion?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<DumOverviewGetDtoGenericResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dumOverviewGet(
        startYear,
        endYear,
        location,
        specificCountry,
        ecosystem,
        toggleAnomalyRating,
        apiVersion,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    }
  };
};

/**
 * DumQueryApi - factory interface
 * @export
 */
export const DumQueryApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = DumQueryApiFp(configuration);
  return {
    /**
     *
     * @param {string} accountId
     * @param {Array<string>} [specificCountry]
     * @param {Array<number>} [toggleAnomalyRating]
     * @param {Array<number>} [status]
     * @param {string} [previousId]
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dumAccountIdGet(
      accountId: string,
      specificCountry?: Array<string>,
      toggleAnomalyRating?: Array<number>,
      status?: Array<number>,
      previousId?: string,
      apiVersion?: string,
      options?: any
    ): AxiosPromise<DumGlobalEventSubmissionListDtoListGenericResponse> {
      return localVarFp
        .dumAccountIdGet(
          accountId,
          specificCountry,
          toggleAnomalyRating,
          status,
          previousId,
          apiVersion,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dumEventIdGet(
      id: string,
      apiVersion?: string,
      options?: any
    ): AxiosPromise<DumGlobalEventDetailsDtoListGenericResponse> {
      return localVarFp
        .dumEventIdGet(id, apiVersion, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [year]
     * @param {number} [month]
     * @param {string} [eventName]
     * @param {string} [previousDumId]
     * @param {number} [location]
     * @param {Array<string>} [specificCountry]
     * @param {Array<number>} [ecosystem]
     * @param {Array<number>} [toggleAnomalyRating]
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dumGet(
      year?: number,
      month?: number,
      eventName?: string,
      previousDumId?: string,
      location?: number,
      specificCountry?: Array<string>,
      ecosystem?: Array<number>,
      toggleAnomalyRating?: Array<number>,
      apiVersion?: string,
      options?: any
    ): AxiosPromise<DumDataHoverDtoListGenericResponse> {
      return localVarFp
        .dumGet(
          year,
          month,
          eventName,
          previousDumId,
          location,
          specificCountry,
          ecosystem,
          toggleAnomalyRating,
          apiVersion,
          options
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [startYear]
     * @param {number} [endYear]
     * @param {number} [location]
     * @param {Array<string>} [specificCountry]
     * @param {Array<number>} [ecosystem]
     * @param {Array<number>} [toggleAnomalyRating]
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dumOverviewGet(
      startYear?: number,
      endYear?: number,
      location?: number,
      specificCountry?: Array<string>,
      ecosystem?: Array<number>,
      toggleAnomalyRating?: Array<number>,
      apiVersion?: string,
      options?: any
    ): AxiosPromise<DumOverviewGetDtoGenericResponse> {
      return localVarFp
        .dumOverviewGet(
          startYear,
          endYear,
          location,
          specificCountry,
          ecosystem,
          toggleAnomalyRating,
          apiVersion,
          options
        )
        .then((request) => request(axios, basePath));
    }
  };
};

/**
 * DumQueryApi - object-oriented interface
 * @export
 * @class DumQueryApi
 * @extends {BaseAPI}
 */
export class DumQueryApi extends BaseAPI {
  /**
   *
   * @param {string} accountId
   * @param {Array<string>} [specificCountry]
   * @param {Array<number>} [toggleAnomalyRating]
   * @param {Array<number>} [status]
   * @param {string} [previousId]
   * @param {string} [apiVersion] The requested API version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DumQueryApi
   */
  public dumAccountIdGet(
    accountId: string,
    specificCountry?: Array<string>,
    toggleAnomalyRating?: Array<number>,
    status?: Array<number>,
    previousId?: string,
    apiVersion?: string,
    options?: AxiosRequestConfig
  ) {
    return DumQueryApiFp(this.configuration)
      .dumAccountIdGet(
        accountId,
        specificCountry,
        toggleAnomalyRating,
        status,
        previousId,
        apiVersion,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {string} [apiVersion] The requested API version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DumQueryApi
   */
  public dumEventIdGet(
    id: string,
    apiVersion?: string,
    options?: AxiosRequestConfig
  ) {
    return DumQueryApiFp(this.configuration)
      .dumEventIdGet(id, apiVersion, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [year]
   * @param {number} [month]
   * @param {string} [eventName]
   * @param {string} [previousDumId]
   * @param {number} [location]
   * @param {Array<string>} [specificCountry]
   * @param {Array<number>} [ecosystem]
   * @param {Array<number>} [toggleAnomalyRating]
   * @param {string} [apiVersion] The requested API version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DumQueryApi
   */
  public dumGet(
    year?: number,
    month?: number,
    eventName?: string,
    previousDumId?: string,
    location?: number,
    specificCountry?: Array<string>,
    ecosystem?: Array<number>,
    toggleAnomalyRating?: Array<number>,
    apiVersion?: string,
    options?: AxiosRequestConfig
  ) {
    return DumQueryApiFp(this.configuration)
      .dumGet(
        year,
        month,
        eventName,
        previousDumId,
        location,
        specificCountry,
        ecosystem,
        toggleAnomalyRating,
        apiVersion,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [startYear]
   * @param {number} [endYear]
   * @param {number} [location]
   * @param {Array<string>} [specificCountry]
   * @param {Array<number>} [ecosystem]
   * @param {Array<number>} [toggleAnomalyRating]
   * @param {string} [apiVersion] The requested API version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DumQueryApi
   */
  public dumOverviewGet(
    startYear?: number,
    endYear?: number,
    location?: number,
    specificCountry?: Array<string>,
    ecosystem?: Array<number>,
    toggleAnomalyRating?: Array<number>,
    apiVersion?: string,
    options?: AxiosRequestConfig
  ) {
    return DumQueryApiFp(this.configuration)
      .dumOverviewGet(
        startYear,
        endYear,
        location,
        specificCountry,
        ecosystem,
        toggleAnomalyRating,
        apiVersion,
        options
      )
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * GlobalEventQueryApi - axios parameter creator
 * @export
 */
export const GlobalEventQueryApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} countryId
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventCountryCountryIdGet: async (
      countryId: string,
      apiVersion?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'countryId' is not null or undefined
      assertParamExists('eventCountryCountryIdGet', 'countryId', countryId);
      const localVarPath = `/event/country/{countryId}`.replace(
        `{${'countryId'}}`,
        encodeURIComponent(String(countryId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (apiVersion !== undefined && apiVersion !== null) {
        localVarHeaderParameter['api-version'] = String(apiVersion);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * GlobalEventQueryApi - functional programming interface
 * @export
 */
export const GlobalEventQueryApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator =
    GlobalEventQueryApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} countryId
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async eventCountryCountryIdGet(
      countryId: string,
      apiVersion?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<GlobalEventDtoListGenericResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.eventCountryCountryIdGet(
          countryId,
          apiVersion,
          options
        );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    }
  };
};

/**
 * GlobalEventQueryApi - factory interface
 * @export
 */
export const GlobalEventQueryApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = GlobalEventQueryApiFp(configuration);
  return {
    /**
     *
     * @param {string} countryId
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    eventCountryCountryIdGet(
      countryId: string,
      apiVersion?: string,
      options?: any
    ): AxiosPromise<GlobalEventDtoListGenericResponse> {
      return localVarFp
        .eventCountryCountryIdGet(countryId, apiVersion, options)
        .then((request) => request(axios, basePath));
    }
  };
};

/**
 * GlobalEventQueryApi - object-oriented interface
 * @export
 * @class GlobalEventQueryApi
 * @extends {BaseAPI}
 */
export class GlobalEventQueryApi extends BaseAPI {
  /**
   *
   * @param {string} countryId
   * @param {string} [apiVersion] The requested API version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GlobalEventQueryApi
   */
  public eventCountryCountryIdGet(
    countryId: string,
    apiVersion?: string,
    options?: AxiosRequestConfig
  ) {
    return GlobalEventQueryApiFp(this.configuration)
      .eventCountryCountryIdGet(countryId, apiVersion, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthReadinessGet: async (
      apiVersion?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/health/readiness`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (apiVersion !== undefined && apiVersion !== null) {
        localVarHeaderParameter['api-version'] = String(apiVersion);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    },
    /**
     *
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthSystemGet: async (
      apiVersion?: string,
      options: AxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/health/system`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {
        method: 'GET',
        ...baseOptions,
        ...options
      };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication Bearer required
      await setApiKeyToObject(
        localVarHeaderParameter,
        'Authorization',
        configuration
      );

      if (apiVersion !== undefined && apiVersion !== null) {
        localVarHeaderParameter['api-version'] = String(apiVersion);
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      };
    }
  };
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async healthReadinessGet(
      apiVersion?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<HealthResponseModel>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.healthReadinessGet(apiVersion, options);
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    },
    /**
     *
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async healthSystemGet(
      apiVersion?: string,
      options?: AxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasicResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.healthSystemGet(
        apiVersion,
        options
      );
      return createRequestFunction(
        localVarAxiosArgs,
        globalAxios,
        BASE_PATH,
        configuration
      );
    }
  };
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = HealthApiFp(configuration);
  return {
    /**
     *
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthReadinessGet(
      apiVersion?: string,
      options?: any
    ): AxiosPromise<HealthResponseModel> {
      return localVarFp
        .healthReadinessGet(apiVersion, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} [apiVersion] The requested API version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthSystemGet(
      apiVersion?: string,
      options?: any
    ): AxiosPromise<BasicResponse> {
      return localVarFp
        .healthSystemGet(apiVersion, options)
        .then((request) => request(axios, basePath));
    }
  };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
  /**
   *
   * @param {string} [apiVersion] The requested API version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HealthApi
   */
  public healthReadinessGet(apiVersion?: string, options?: AxiosRequestConfig) {
    return HealthApiFp(this.configuration)
      .healthReadinessGet(apiVersion, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} [apiVersion] The requested API version
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HealthApi
   */
  public healthSystemGet(apiVersion?: string, options?: AxiosRequestConfig) {
    return HealthApiFp(this.configuration)
      .healthSystemGet(apiVersion, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
